import { Typography, Divider } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import RowStack from 'components/atoms/container/RowStack'
import InCardStack from 'components/atoms/container/InCardStack'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'

const OverallScoreBox = ({ selfScore, otherScore, forPathAssessment }) => {
  const { t } = useTranslation()

  const ScoreText = ({ label, score, color = 'primary' }) => {
    return (
      <InCardStack spacing={0}>
        <Typography variant='body1KindaSmall' color='primary'>
          {label}
        </Typography>
        <Typography
          variant='h1'
          fontSize={forPathAssessment ? 48 : 32}
          lineHeight={'110%'}
          color={color}>
          {score}
        </Typography>
      </InCardStack>
    )
  }

  return (
    <BoxWithBackground
      backgroundColor={colors.White}
      padding={8}
      borderRadius={3}
      showBoxShadow={true}>
      <RowStack spacing={12} justifyContent={'center'}>
        <ScoreText
          label={t('goalsArea.self')}
          score={selfScore?.toFixed(1)}
          color={colors.Teal400}
        />
        <Divider
          orientation='vertical'
          sx={{
            height: 38,
            borderColor: colors.Grey200
          }}
        />
        <ScoreText
          label={t('goalsArea.others')}
          score={otherScore > 0 ? otherScore?.toFixed(2) : '-'}
        />
      </RowStack>
    </BoxWithBackground>
  )
}

export default OverallScoreBox
